import store from '@/store'
import { REGISTER_USER, RESET_FORM_DATA } from '@/store/modules/register.module'
import constants from '@/constants'
import analytics from '@core/utils/analytics'
import { AUTH_REGISTER_V2_CHILDREN } from '@/router/routes/utils'

export const registerAction = async ({ router }) => {
  const formData = {
    role: store.state.register.formData.userType,
    entityName: store.state.register.formData.companyName,
    firstName: store.state.register.formData.firstName,
    lastName: store.state.register.formData.lastName,
    country: store.state.register.formData.country.name,
    countryCode: store.state.register.formData.country.dial_code,
    companyRole: store.state.register.formData.companyRole,
    phone: store.state.register.formData.phone,
    email: store.state.register.formData.email,
    password_length: store.state.register.formData.password.length,
    launchDate: store.state.register.formData.selectedLaunchDate,
  }

  // Track start
  analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.CREATE_ACCOUNT_SIGNUP_CLICK, { formData })

  try {
    const response = await store.dispatch(REGISTER_USER)

    if (response && response.data) {
      analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.REGISTRATION_SUCCESS, {
        formData,
        response,
      })
      store.commit(RESET_FORM_DATA)
      router.push({ name: AUTH_REGISTER_V2_CHILDREN.CONFIRM })
    }
  } catch (error) {
    analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.REGISTRATION_FAILED, {
      formData,
      error: JSON.stringify(error),
    })
  }
}
